import React from 'react';
import PropTypes from 'prop-types';
import TextFieldWrapper from '../reusable/TextFieldWrapper/TextFieldWrapper.js';
import { EMAIL_LABEL } from '../../static/keyWords.js';
import { EMAIL_SUPPORT_TEXT } from './loginHelpers.js';

const EmailStep = ({email, setEmail, invalid = false, disabled = false}) => {
  return (
    <div className="emailStep">
      <TextFieldWrapper
        label={EMAIL_LABEL}
        onChange={(event) => setEmail(event.target.value)}
        value={email}
        inputType="email"
        name="email"
        required
        invalid={invalid}
        disabled={disabled}
        supportText={EMAIL_SUPPORT_TEXT}
        skipIsTouched={invalid}
        htmlFor="login-email"
        inputId="login-email"
        textFieldClassName="emailField"
        variant="outlined"
      />
    </div>
  );
};

EmailStep.propTypes = {
  email: PropTypes.string,
  setEmail: PropTypes.func,
  invalid: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default EmailStep;
